const TABS = [
  { key: "overview", label: "Overview", testId: "account-tab-overview" },
  { key: "history", label: "History", testId: "account-tab-history" },
  { key: "agreement", label: "Current Agreement", testId: "account-tab-agreement" },
  { key: "vehicledocs", label: "Vehicle Documentation", testId: "account-tab-vehicledocs" },
  { key: "services", label: "Service Requests", testId: "account-tab-services" },
  { key: "billing", label: "Billing & Disputes", testId: "account-tab-billing" },
  { key: "feedback", label: "Feedback", testId: "account-tab-feedback" },
  { key: "profile", label: "Profile", testId: "account-tab-profile" },
];

const ADMIN_TABS = [
  { key: "review", label: "Doc Review", testId: "account-tab-review" },
  { key: "blogcms", label: "Blog CMS", testId: "account-tab-blogcms" },
  { key: "fleetgallery", label: "Fleet Gallery", testId: "account-tab-fleetgallery" },
  { key: "reviews", label: "Reviews", testId: "account-tab-reviews" },
  { key: "partnerleads", label: "Partner Leads", testId: "account-tab-partnerleads" },
  { key: "outbox", label: "Outbox", testId: "account-tab-outbox" },
];

// Old deep links keep working
export const LEGACY_TAB_MAP = { bookings: "history", fines: "billing", complaints: "billing", documents: "vehicledocs", accidents: "services" };

export const AccountTabs = ({ tab, setTab, isAdmin }) => {
  const tabs = isAdmin ? [...TABS, ...ADMIN_TABS] : TABS;
  return (
    <div className="flex flex-wrap rounded-md overflow-hidden border border-[#d5ddd5] mb-6 w-fit">
      {tabs.map((t) => (
        <button key={t.key} onClick={() => setTab(t.key)}
          className={`px-4 py-2.5 text-xs font-medium uppercase tracking-wide transition-colors ${tab === t.key ? "bg-[#009900] text-white" : "bg-white text-[#144733]"}`}
          data-testid={t.testId}>{t.label}</button>
      ))}
    </div>
  );
};
